module.exports = __webpack_public_path__ + "4b78d5bccd8b0d9970a2087c74f520f9.png";